export default "/bundles/assets/online_0b72a2bf41a8c0db7356d7528ec167bf.png";